var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRootSignAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM13 8.25C12.7 8.25 12.4288 8.4288 12.3106 8.70456L9.74701 14.6864L7.53033 12.4697C7.23744 12.1768 6.76256 12.1768 6.46967 12.4697L5.46967 13.4697C5.17678 13.7626 5.17678 14.2374 5.46967 14.5303C5.76256 14.8232 6.23744 14.8232 6.53033 14.5303L7 14.0607L9.46967 16.5303C9.64565 16.7063 9.89745 16.7835 10.1418 16.7365C10.3862 16.6894 10.5913 16.5242 10.6894 16.2954L13.4945 9.75H18C18.4142 9.75 18.75 9.41421 18.75 9C18.75 8.58579 18.4142 8.25 18 8.25H13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootSignAlt1);
export default __webpack_public_path__ + "static/media/root-sign-alt-1.d306ac76ad4c0b8099eb90743a211fdf.svg";
export { ForwardRef as ReactComponent };